'use client';

import * as React from 'react';
import {
  isDayPickerMultiple,
  isDayPickerRange,
  isDayPickerSingle,
} from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Calendar, type CalendarProps } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

const DatePicker: React.FC<CalendarProps> = (props) => {
  const { t } = useTranslation();
  const date = props.selected;

  const formatted = React.useMemo(() => {
    if (isDayPickerSingle(props) && props.selected) {
      return format(props.selected, 'PPP');
    }
    if (isDayPickerMultiple(props) && props.selected) {
      return props.selected.map((_date) => format(_date, 'PPP')).join(', ');
    }
    if (isDayPickerRange(props)) {
      return `${props.selected?.from ? format(props.selected.from, 'PPP') : ''} - ${props.selected?.to ? format(props.selected.to, 'PPP') : ''}`;
    }
    return t('components.datePicker.placeholder');
  }, [props, t]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'w-[280px] justify-start text-left font-normal',
            !date && 'text-muted-foreground'
          )}>
          <CalendarIcon className='mr-2 h-4 w-4' />
          <span>{formatted}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0'>
        <Calendar {...props} />
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
